var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// https://github.com/rxaviers/async-pool/blob/master/lib/es7.js
export function asyncPool(poolLimit, array, fn) {
    return __awaiter(this, void 0, void 0, function* () {
        const ret = [];
        const executing = new Set();
        for (const item of array) {
            const prom = Promise.resolve().then(() => fn(item));
            ret.push(prom);
            if (poolLimit <= array.length) {
                executing.add(prom);
                prom.then(() => executing.delete(prom));
                if (executing.size >= poolLimit) {
                    yield Promise.race(executing);
                }
            }
        }
        return Promise.all(ret);
    });
}
//# sourceMappingURL=asyncPool.js.map